import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-autocomplete-input',
  templateUrl: './autocomplete-input.component.html',
  styleUrls: ['./autocomplete-input.component.scss']
})
export class AutocompleteInputComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() model: any;
  @Input() maxLength: number;
  @Input() data: any[];
  @Input() disabled: boolean;
  @Input() isSubmit: boolean;
  @Input() required: boolean;
  @Input() name: string;

  @Output() value: EventEmitter<string> = new EventEmitter<string>();
  @Output() autoComplete: EventEmitter<string> = new EventEmitter<string>();
  @Output() enterManual: EventEmitter<string> = new EventEmitter<string>();


  queryDataTimeoutIndex: any;
  myControl = new FormControl();
  filteredOptions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.myControl.valueChanges.subscribe(res => {
      if (res.length >= 3 && !this.disabled) {
        if (this.queryDataTimeoutIndex) {
          clearTimeout(this.queryDataTimeoutIndex);
        }
        this.queryDataTimeoutIndex = setTimeout(() => {
          this.value.emit(res.toLowerCase());
        }, 500);
      } else {
        this.value.emit('');
      }
    });
  }

  ngOnChanges() {
    if (!this.model) {
      this.data = [];
    }
    if (this.data) {
      this.filteredOptions.next(this.data);
    }
    if (this.isSubmit) {
      this.myControl.markAsTouched();
    }
  }

  public optionSelected(event) {
    if (event.option.value) {
      this.autoComplete.emit(event.option.value);
    }
  }

  public setData(event) {
    this.enterManual.emit(this.model);
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
}
